'use strict';

// Class definition
var KTChartsWidget36 = (function () {
  var chart = {
    self: null,
    rendered: false,
  };

  // Private methods
  var initChart = function (chart) {
    var element = document.getElementById('kt_charts_widget_36');

    if (!element) {
      return;
    }

    var height = parseInt(KTUtil.css(element, 'height'));
    var labelColor = KTUtil.getCssVariableValue('--bs-gray-500');
    var borderColor = KTUtil.getCssVariableValue('--bs-border-dashed-color');
    var baseprimaryColor = KTUtil.getCssVariableValue('--bs-primary');
    var lightprimaryColor = KTUtil.getCssVariableValue('--bs-primary');
    var basesuccessColor = KTUtil.getCssVariableValue('--bs-success');
    var lightsuccessColor = KTUtil.getCssVariableValue('--bs-success');

    var options = {
      series: [
        {
          name: 'Inbound Calls',
          data: [
            65, 80, 80, 60, 60, 45, 45, 80, 80, 70, 70, 90, 90, 80, 80, 80, 60,
            60, 50,
          ],
        },
        {
          name: 'Outbound Calls',
          data: [
            90, 110, 110, 95, 95, 85, 85, 95, 95, 115, 115, 100, 100, 115, 115,
            95, 95, 85, 85,
          ],
        },
      ],
      chart: {
        fontFamily: 'inherit',
        type: 'area',
        height: height,
        toolbar: {
          show: false,
        },
      },
      plotOptions: {},
      legend: {
        show: false,
      },
      dataLabels: {
        enabled: false,
      },
      fill: {
        type: 'gradient',
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.4,
          opacityTo: 0.2,
          stops: [15, 120, 100],
        },
      },
      stroke: {
        curve: 'smooth',
        show: true,
        width: 3,
        colors: [baseprimaryColor, basesuccessColor],
      },
      xaxis: {
        categories: [
          '',
          '8 AM',
          '81 AM',
          '9 AM',
          '10 AM',
          '11 AM',
          '12 PM',
          '13 PM',
          '14 PM',
          '15 PM',
          '16 PM',
          '17 PM',
          '18 PM',
          '18:20 PM',
          '18:20 PM',
          '19 PM',
          '20 PM',
          '21 PM',
          '',
        ],
        axisBorder: {
          show: false,
        },
        axisTicks: {
          show: false,
        },
        tickAmount: 6,
        labels: {
          rotate: 0,
          rotateAlways: true,
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
        crosshairs: {
          position: 'front',
          stroke: {
            color: [baseprimaryColor, basesuccessColor],
            width: 1,
            dashArray: 3,
          },
        },
        tooltip: {
          enabled: true,
          formatter: undefined,
          offsetY: 0,
          style: {
            fontSize: '12px',
          },
        },
      },
      yaxis: {
        max: 120,
        min: 30,
        tickAmount: 6,
        labels: {
          style: {
            colors: labelColor,
            fontSize: '12px',
          },
        },
      },
      states: {
        normal: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        hover: {
          filter: {
            type: 'none',
            value: 0,
          },
        },
        active: {
          allowMultipleDataPointsSelection: false,
          filter: {
            type: 'none',
            value: 0,
          },
        },
      },
      tooltip: {
        style: {
          fontSize: '12px',
        },
      },
      colors: [lightprimaryColor, lightsuccessColor],
      grid: {
        borderColor: borderColor,
        strokeDashArray: 4,
        yaxis: {
          lines: {
            show: true,
          },
        },
      },
      markers: {
        strokeColor: [baseprimaryColor, basesuccessColor],
        strokeWidth: 3,
      },
    };

    chart.self = new ApexCharts(element, options);

    // Set timeout to properly get the parent elements width
    setTimeout(function () {
      chart.self.render();
      chart.rendered = true;
    }, 200);
  };

  // Public methods
  return {
    init: function () {
      initChart(chart);

      // Update chart on theme mode change
      KTThemeMode.on('kt.thememode.change', function () {
        if (chart.rendered) {
          chart.self.destroy();
        }

        initChart(chart);
      });
    },
  };
})();

// Webpack support
if (typeof module !== 'undefined') {
  module.exports = KTChartsWidget36;
}

// On document ready
KTUtil.onDOMContentLoaded(function () {
  KTChartsWidget36.init();
});
